
import { Component, Vue } from 'vue-property-decorator';
import { OAClientModel } from '@/models/OAClient';

@Component({
  components: {
  },
})
export default class OAClientEditPage extends Vue {
  public isLoading: boolean = true;
  public oaClient: OAClientModel = new OAClientModel();
  public messageError: string = '';
  public isError: boolean = false;
  public showDeleteDialog: boolean = false;
  public isDeleting: boolean = false;

  public async created() {
    this.isLoading = true;
    const clientId = this.$route.params.id;
    this.oaClient.clientId = clientId;
    try {
      await this.oaClient.fetch();
    } catch (e: any) {
      this.isError = true;
      this.messageError = 'Failed to load client data.';
    }
    this.isLoading = false;
  }

  public async saveClient() {
    this.isError = false;
    try {
      await this.oaClient.save();
      await this.$router.push('/oa_clients');
    } catch (e: any) {
      this.isError = true;
      this.messageError = e.message;
    }
  }

  public promptDelete() {
    this.showDeleteDialog = true;
  }

  public closeDeleteDialog() {
    this.showDeleteDialog = false;
  }

  public async confirmDelete() {
    this.isDeleting = true;
    this.isError = false;
    try {
      await this.oaClient.delete();
      this.$router.push('/oa_clients');
    } catch (e: any) {
      console.error(e);
      this.isError = true;
      this.messageError = 'Failed to delete client.';
    } finally {
      this.isDeleting = false;
      this.showDeleteDialog = false;
    }
  }
}
